import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type NegociacaoFornecedorSavedFilterProps = {
  filterName: string;
  data: {
    label: string;
    value: string;
    name: string;
  };
};

const initialState: NegociacaoFornecedorSavedFilterProps = {
  filterName: '',
  data: {
    name: '',
    value: '',
    label: '',
  },
};

const slice = createSlice({
  name: '/ipa/gerenciador-de-precos/savedFilter',
  initialState,
  reducers: {
    NEGOTIATION_SET_SAVEDFILTER(
      state,
      action: PayloadAction<{
        data: NegociacaoFornecedorSavedFilterProps;
      }>,
    ) {
      return action.payload.data;
    },
    NEGOTIATION_CHANGE_SAVEDFILTER(
      state,
      action: PayloadAction<{
        key: keyof typeof initialState;
        data: NegociacaoFornecedorSavedFilterProps['data'];
      }>,
    ) {
      state.data = action.payload.data;
    },
    NEGOTIATION_SET_SAVEDFILTER_NAME(
      state,
      action: PayloadAction<{
        value: string;
      }>,
    ) {
      state.filterName = action.payload.value;
    },
    NEGOTIATION_RESET_SAVEDFILTER() {
      return initialState;
    },
  },
});

const { NEGOTIATION_SET_SAVEDFILTER, NEGOTIATION_CHANGE_SAVEDFILTER, NEGOTIATION_SET_SAVEDFILTER_NAME, NEGOTIATION_RESET_SAVEDFILTER } = slice.actions;

export { NEGOTIATION_CHANGE_SAVEDFILTER, NEGOTIATION_RESET_SAVEDFILTER, NEGOTIATION_SET_SAVEDFILTER, NEGOTIATION_SET_SAVEDFILTER_NAME };

export default slice.reducer;
